export default __webpack_public_path__ + "static/media/viber.2afcede1.svg";